<template lang="html">
  <div class="d-flex align-items-center justify-content-center h-100">
    <div :class="[`bg-${stickerBg}`, 'rounded-circle sticker sticker--circle']" :style="{borderColor: stickerBorderColor}">
      <svg width="4.5em" height="4.5em" viewBox="0 0 16 16" :class="['bi bi-paperclip sticker--logo', `text-${iconColor}`]" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"></path>
      </svg>
    </div>
  </div>
</template>

<script>

export default {
  name: 'clip-sticker',
  props: {
    stickerBg: {
      type: String,
      required: false,
      default: 'service-light'
    },
    iconColor: {
      type: String,
      required: false,
      default: 'service'
    }
  },
  computed: {
    stickerBorderColor () {
      return this.stickerBg === 'danger'
        ? '#ffcacd' // 255,202,205,1
        : '#e9ecef'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "styles/customs/sticker.scss";
</style>



// WEBPACK FOOTER //
// src/components/ui-component/util/sticker/clip.vue